// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import DateField from "../../ui/DateField";
import TimeField from "../../ui/TimeField";
import Button from "../../ui/Button";
import { showError, showMessage } from "../../ui/Message";
import { bm_date, bm_time } from "../../utils/Utils";
import { ENUMS } from "../../utils/Enums";
import dayjs from "dayjs";
import DateInput from "../../ui/DateInput";
import Select from "../../ui/Select";
import { ROUTES } from "../../utils/Routes";

export default function RangeDynamic(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, edit = false } = props;

    const { value = 1, type = "" } = filter;

    let text = filter.text;
    let _data = ENUMS.REPORT_FILTERS.find(item => item.value === type) || false;

    if (_data) {
        text = _data.text;
    }


    let preset = filter?.value_1




    const fields = [
        { include: true, label: "preset", key: "preset", value: (edit) ? preset : "", help: "Select preset" },
        { include: true, key: "comparison", value: (edit) ? filter?.comparison : "=", help: "= equal, < less, > greater" },
        { include: true, key: "value_2", value: (edit) ? filter?.value_2 : "0", help: "Enter the data to complete this filter." },
        { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];


    const save = (tabs) => {
        const comparison = tabs.find(f => f.key === "comparison").value
        const _preset = tabs.find(f => f.key === "preset")?.value || "";


        let value_1 = _preset
        let value_2 = tabs.find(f => f.key === "value_2").value;



        const _f = {
            ...FILTER,
            type: value,
            comparison: comparison,
            value_1: value_1,
            value_2: value_2.toString()
        }


        console.log(_f)
        onSave(_f, filter);
    }

    return (
        <FilterBase controller={controller} fields={fields.filter(item => item.include)} onClose={() => onClose()} onSave={save}>
            {({ editProps, update, tabs, next, setIndex }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <Select
                            controller={controller}
                            {...editProps("preset")}
                            showSearch={false}
                            offset={[4, 0]}
                            align="top"
                            top={true}
                            title="Select..."
                            options={[

                                { value: "6", label: "Last 6 Months" },
                                { value: "12", label: "Last 12 Months" },
                            ]}
                            placeholder="Select..."
                            returnRoute={ROUTES.REPORTS.FILTER_EDIT}
                            onSelect={(e) => setTimeout(() => { setIndex("comparison") }, 0)}
                            onNext={() => { setTimeout(() => { setIndex("comparison") }, 0) }}
                            onPrev={() => { setTimeout(() => { }, 0) }}
                            onClick={() => { }}
                        />

                        <div>is</div>
                        <Input {...editProps("comparison")} chars={[">", "<", "="]} maxLength={1} width={20} />
                        <Input {...editProps("value_2")} number maxLength={3} width={35} />
                        <Button onClick={() => save(tabs)} {...editProps("save")}>Save</Button>
                    </Space>
                </div>
            )}

        </FilterBase>
    );
}
